<template>
  <div>
    <b-modal
      id="superomaticModal"
      ref="superomaticModal"
      title="Выберите денминацию"
      size="md"
      :hide-footer="true"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
      modal-class="main-modal main-block"
      header-class="text-white border-0"
      header-close-variant="orange"
      title-class="text-center underlined-muted-title"
      body-class="pt-0"
      @cancel="goHome"
      @esc="goHome"
      @backdrop="goHome"
      @headerclose="goHome"
    >
      <b-card no-body class="col-12 border-0 text-white bg-transparent">
        <div class="form-group">
          <div class="col-md-12 mx-auto mb-3 text-center px-0">
            <div class="col-12 mx-auto supero-game-info-area mb-3">
              <h3 class="text-center text-muted">
                {{ game.name }}
              </h3>
              <img
                :src="game.picture" :alt="'VipMagnit online Casino ' +game.name "
                class="supero-game-img"
              >
            </div>
            <div class="col-12 row mx-0 justify-content-center">
              <div
                v-for="(value, index) in denominations"
                :key="index" class="radio col-6 col-sm-3 col-lg-3 mx-auto text-left"
              >
                <label :class="denomination === value ? 'selected-denom' : ''" class="denomination-label">
                  <input v-model="denomination" type="radio" :value="value">
                  <span class="denomination-radio-btn"></span>
                  <span class="denomination-value">{{ value }}</span>
                </label>
              </div>
            </div>

            <div class="row w-100 mx-0 mt-2 justify-content-center">
              <div class="col-5 col-lg-5 px-0 mx-2 text-right mx-auto text-center">
                <a class="btn dark-btn btn-block" @click="goHome()">Отмена</a>
              </div>
              <div class="col-5 col-lg-5 px-0 mx-0 mx-lg-2 mx-auto ">
                <button
                  name="submit"
                  class="btn main-btn w-100 border-0"
                  @click.prevent="gotoSuperoView()">
                  Играть
                </button>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'SuperomaticSelecter',
  props: ['game'],
  data () {
    return {
      denomination: 1,
      denominations: [
        0.1,
        0.25,
        0.5,
        1
      ]
    }
  },
  computed: {
    isMobile () {
      return this.$_config.environment.mobile
    }
  },
  mounted () {
     this.$refs.superomaticModal.show()
  },
  methods: {
    gotoSuperoView () {
      this.$emit('superoNominationSelected', this.denomination)
      this.$root.$emit('bv::hide::modal', 'superomaticModal')
      return false
    },
    goHome () {
      return window.location = ""
    }
  }
}
</script>

<style>
  .supero-game-img{
    height: 150px;
  }
</style>
